import Vue from 'vue'
import VueRouter from 'vue-router'
import { localStore } from '@/utils/store'
import routes from './routes'
import store from '@/store'
// @ts-ignore
import constStorage from '@constant/storage'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, _, next) => {
  document.title = to.meta?.name || 'yololiv saas'
  store.commit('currentRouteUpdate', to)
  next()
})

export default router
